// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// Humans Module

// Define the attributes and actions for Humans

define('Humans',['require','Utilities'],function (require) {
    'use strict';

    var // Require.js module dependencies
        Utilities = require('Utilities'),

        // Dependent modeles
        utilities,

        // Class names
        leftClass = 'turn-left',
        rightClass = 'turn-right',
        showClass = 'show-human',
        jumpClass = 'jump',

        // Attributes
        colors = [
            'blue',
            'lightblue',
            'green',
            'lightgreen',
            'red',
            'lightred',
            'yellow',
            'orange',
            'purple',
            'gray'
        ],
        headcount = 30,
        positionDivs = [],
        attributes = [
            { top:  '30px',  left: '175px',  orientation: rightClass },
            { top:  '40px',  left: '105px',  orientation: ''         },
            { top:  '50px',  left: '190px',  orientation: ''         },
            { top:  '55px',  left:  '90px',  orientation: ''         },
            { top:  '55px',  left: '145px',  orientation: rightClass },
            { top:  '80px',  left: '175px',  orientation: leftClass  },
            { top:  '90px',  left: '130px',  orientation: ''         },
            { top:  '95px',  left: '195px',  orientation: leftClass  },
            { top:  '90px',  left:  '65px',  orientation: rightClass },
            { top:  '95px',  left: '220px',  orientation: ''         },
            { top: '100px',  left:  '95px',  orientation: ''         },
            { top: '125px',  left: '145px',  orientation: rightClass },
            { top: '130px',  left: '185px',  orientation: leftClass  },
            { top: '135px',  left: '130px',  orientation: ''         },
            { top: '130px',  left: '235px',  orientation: leftClass  },
            { top: '145px',  left:  '55px',  orientation: rightClass },
            { top: '160px',  left: '190px',  orientation: ''         },
            { top: '145px',  left:  '90px',  orientation: ''         },
            { top: '150px',  left: '155px',  orientation: rightClass },
            { top: '155px',  left: '245px',  orientation: leftClass  },
            { top: '170px',  left:  '35px',  orientation: ''         },
            { top: '175px',  left: '215px',  orientation: leftClass  },
            { top: '180px',  left:  '65px',  orientation: rightClass },
            { top: '195px',  left: '185px',  orientation: ''         },
            { top: '190px',  left:  '90px',  orientation: ''         },
            { top: '185px',  left: '125px',  orientation: rightClass },
            { top: '200px',  left: '235px',  orientation: leftClass  },
            { top: '205px',  left: '150px',  orientation: ''         },
            { top: '210px',  left: '100px',  orientation: ''         },
            { top: '205px',  left:  '55px',  orientation: ''         },
        ],

        // Animation coefficients
        animationTurns = 1000,
        animationTurnDelay = 500,
        animationJumps = 500,
        animationJumpDelay = 1000,
        animationRunning = false,

        // Other instance variables
        crowdDiv = document.createElement('div'),
        middle;


    // Constructor
    function Humans(numHumans) {
        // Instantiate dependent modules
        utilities = new Utilities();

        // Allocate headcount
        if (numHumans && numHumans > 0) {
            headcount = numHumans;
        }

        // Create random colored humans and place them
        var randomColors = utilities.shuffle(colors),
            humanImg, humanDiv;
        for (var i=0; i<headcount; i++) {
            // Create random colored human
            humanImg = document.createElement('img');
            humanImg.src = './img/humans/' +
                randomColors[i % randomColors.length] + '.png';

            // Put them in the box
            humanDiv = document.createElement('div');
            humanDiv.appendChild(humanImg);

            // Assign attributes
            humanDiv.style.top = attributes[i].top;
            humanDiv.style.left = attributes[i].left;
            humanDiv.style.zIndex = 100+i;

            // Turn them left or right initially
            if (attributes[i].orientation) {
                humanDiv.classList.add(attributes[i].orientation);
            }

            // Add them to the collective
            positionDivs.push(humanDiv);
            crowdDiv.appendChild(humanDiv);
            crowdDiv.setAttribute('id', 'humans-div');
        }
    };

    // Get the container for the crowd of humans
    Humans.prototype.getCrowdDiv = function () {
        return crowdDiv;
    };

    // Make all the humans visible
    Humans.prototype.show = function () {
        // Show humans in within the total time
        var totalTime = 2000;
        for (var i=0; i<positionDivs.length; i++) {
            setTimeout(function (positionDiv) {
                positionDiv.classList.add(showClass);
            }.bind(this, positionDivs[i]), totalTime-(
                Math.pow(positionDivs.length-i,2)*totalTime/1000));
        }
        // Determine middle position of the parent container
        middle = positionDivs[0].parentNode.clientWidth / 2;
    };

    // Raise arms in celebration
    Humans.prototype.raiseArms = function (raise) {
        var index, human;
        for (var i=0; i<positionDivs.length; i++) {
            human = positionDivs[i].children[0];
            index = human.src.indexOf('_yes.png');
            // Raise if not already raised
            if (raise && index < 0) {
                human.src = human.src.replace('.png','_yes.png');
            } else if (!raise && index > 0) {
                human.src = human.src.replace('_yes.png','.png');
            }
        }
    };

    // Set position and orientation for human
    Humans.prototype.setOrientation = function (humansIndex, orientation) {
        if (humansIndex < headcount) {
            if (orientation === leftClass) {
                // Turn human left
                positionDivs[humansIndex].classList.remove(rightClass);
                positionDivs[humansIndex].classList.add(leftClass);
                attributes[humansIndex].orientation = leftClass;
            } else if (orientation === rightClass) {
                // Turn human right
                positionDivs[humansIndex].classList.remove(leftClass);
                positionDivs[humansIndex].classList.add(rightClass);
                attributes[humansIndex].orientation = rightClass;
            } else {
                // Set human facing forward
                positionDivs[humansIndex].classList.remove(leftClass);
                positionDivs[humansIndex].classList.remove(rightClass);
                attributes[humansIndex].orientation = '';
            }
        }
    };

    // Turn humans back and forth
    Humans.prototype.turn = function (iteration) {
        if (iteration > 0) {
            // Pick a random human
            var randomIndex = Math.floor(Math.random()*headcount);
            // Turn right or left based on position
            if (parseInt(attributes[randomIndex].left) < middle) {
                // Turn right or return to straight
                if (attributes[randomIndex].orientation) {
                    this.setOrientation(randomIndex, '');
                } else {
                    this.setOrientation(randomIndex, rightClass);
                }
            } else {
                // Turn left or return to straight
                if (attributes[randomIndex].orientation) {
                    this.setOrientation(randomIndex, '');
                } else {
                    this.setOrientation(randomIndex, leftClass);
                }
            }
            // Go for the next iteration
            if (animationRunning) {
                var delay = Math.floor(Math.random()*2*animationTurnDelay);
                setTimeout(function () {
                    this.turn(iteration-1);
                }.bind(this), delay);
            }
        }
    };

    // Make random humans jump to signify impatience
    Humans.prototype.jump = function (iteration) {
        if (iteration > 0) {
            // Pick a random human
            var randomHuman =
                positionDivs[Math.floor(Math.random()*headcount)];
            // Make them jump
            randomHuman.classList.add(jumpClass);
            setTimeout(function () {
                randomHuman.classList.remove(jumpClass);
            }, 250);
            // Go for next iteration
            if (animationRunning) {
                var delay = Math.floor(Math.random()*2*animationJumpDelay);
                setTimeout(function () {
                    this.jump(iteration-1);
                }.bind(this), delay);
            }
        }
    };

    // Animate on/off
    Humans.prototype.runAnimation = function (animate) {
        if (animate) {
            animationRunning = true;
            this.turn(animationTurns);
            this.jump(animationJumps);
        } else {
            animationRunning = false;
        }
    };

    // Return the constructor
    return Humans.prototype.constructor;
});

